const messages: any = {
    1001: 'Credenciales inválidas'
}

export const mapApiCodeMessage = (code: number) => {
    return messages[code] || 'Error interno, validar con administrador';
}